globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.Websites = appCustomerSpace.Controllers.Websites || {};

appCustomerSpace.Controllers.Websites.OnlineJumpProjectsController = (function(superClass)
{
  utils.extend(OnlineJumpProjectsController, superClass);

  function OnlineJumpProjectsController() {
    this.$html = $("body.online-jump-project");
    return OnlineJumpProjectsController.__super__.constructor.apply(this, arguments);
  }

  $.extend(OnlineJumpProjectsController.prototype, {
    init: function() {
      return OnlineJumpProjectsController.__super__.init.apply(this, arguments);
    },
    specific_task: function() {
      var _this = this;

      utils.require([assets.sharer], function(){
        window.Sharer.init();
      });

      _this.$form         = _this.$html.find(".edit_business_services_abstract_tasks_task");
      _this.$statusInput  = _this.$form.find("input#business_services_abstract_tasks_task_status");
      _this.$formButtons  = _this.$form.find("button[type='submit']");

      _this.$formButtons.on("click", function(e) {
        e.preventDefault();
        _this.$statusInput.val($(this).data("value"));
        _this.$form.submit();
      });
    }
  });

  return OnlineJumpProjectsController;

})(appCustomerSpace.Controllers.MainController);
